import React from "react";
import { Typography } from "@material-ui/core";

import classes from "./SessionExpiredWarning.module.scss";

const SessionExpiredWarning = () => {
  return (
    <div className={classes.container}>
      <Typography variant="h2" className={classes.heading}>
        Your session is expired, <br />
        To continue, please refresh the page.
      </Typography>
    </div>
  );
};

export default SessionExpiredWarning;
